import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Tooltip,
  Button,
} from '@lockerpm/design';

import {
  MinusCircleOutlined,
} from "@ant-design/icons";

import itemsComponents from "../../../../components/items";

import global from "../../../../config/global";
import authServices from "../../../../services/auth";

const TwoFA = (props) => {
  const {
    className = '',
  } = props;
  const { DocLink } = itemsComponents;
  const { t } = useTranslation();

  const userInfo = useSelector(state => state.auth.userInfo);
  const isMobile = useSelector(state => state.system.isMobile);

  const [factor2, setFactor2] = useState(null);

  useEffect(() => {
    getFactor2();
  }, [])

  const getFactor2 = async () => {
    const result = await authServices.get_factor2();
    setFactor2(result)
  }

  return (
    <div className={className}>
      <div className="flex justify-between">
        <p className="font-semibold text-xl">
          {t('security.two_fa.title')}
        </p>
        <Tooltip
          title={userInfo?.is_require_2fa ? t('security.two_fa.require_2fa') : ''}
        >
          <Button
            type='primary'
            ghost
            icon={<MinusCircleOutlined />}
            disabled={userInfo?.is_require_2fa}
            onClick={() => window.open(`${global.urls.LOCKER_ID_URL}/security/two-step-verification`, '_blank')}
          >
            {isMobile ? '' : (factor2?.is_factor2 ? t('security.two_fa.turn_off') : t('security.two_fa.turn_on'))}
          </Button>
        </Tooltip>
      </div>
      <p className="mt-1">
        {t('security.two_fa.description')}
      </p>
      <DocLink
        className="mt-2"
        title={t('security.two_fa.doc')}
        docKey="TWO_FA_FOR_LOCKER_ACCOUNT"
      />
    </div>
  );
}

export default TwoFA;
